import { twMerge } from 'tailwind-merge';

export const AnalyticsBadge = ({ text, color }: { text: string; color: string }) => {
  return (
    <div className={twMerge('tw-rounded-[6px] tw-px-[10px] tw-py-[2px]', color)}>
      <span className="tw-text-[12px] tw-font-semibold tw-uppercase tw-text-white">{text}</span>
    </div>
  );
};
